var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastBroadcasting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#03a66d;}.cls-1{opacity:0.2;}.cls-3{fill:#03a66d;}.cls-4{fill:#03a66d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,0A22,22,0,1,0,44,22,22,22,0,0,0,22,0Zm0,34.24A12.24,12.24,0,1,1,34.24,22,12.24,12.24,0,0,1,22,34.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,22H34.24A12.24,12.24,0,0,0,23.55,9.86,11.21,11.21,0,0,0,22,9.76V0A22,22,0,0,1,42.71,14.55,22.28,22.28,0,0,1,43.79,19,21.8,21.8,0,0,1,44,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.71,14.55C35.44.43,24.08,1.91,24.08,1.91V9.32l-.53.54A11.21,11.21,0,0,0,22,9.76V0A22,22,0,0,1,42.71,14.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.79,19A21.8,21.8,0,0,1,44,22H34.24A12.24,12.24,0,0,0,23.55,9.86,11.21,11.21,0,0,0,22,9.76V6.6A11.28,11.28,0,0,1,24.08,7c8.61,2.16,10.44,12.11,10.44,12.11S41.18,19,43.79,19Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastBroadcasting);
export default __webpack_public_path__ + "static/media/toast_broadcasting.df108abfcc35f7ccf704f053e76261ec.svg";
export { ForwardRef as ReactComponent };